import { Component, EventEmitter, Input, Output } from '@angular/core';
import { NotificationVariant } from './notification.constants';

@Component({
  selector: 'app-notification',
  template: `<div [ngClass]="{ open: messageText, 'tw-mb-20': variant === NotificationVariant.ABOVE_STICKY_FOOTER }">{{messageText}}</div>`,
  standalone: false,
})
export class NotificationComponent {
  messageText: any = '';
  interval: any;
  @Input() variant: NotificationVariant = NotificationVariant.DEFAULT;
  readonly NotificationVariant = NotificationVariant;

  @Input('message')
  set message(text: string) {
    if (!text) return;
    this.openSnackBar(text);
  }

  @Output('messageChange') messageChange: EventEmitter<string> = new EventEmitter();

  ngOnInit(): void {}

  openSnackBar(message: string): void {
    clearInterval(this.interval);
    if (message.toLowerCase().includes('unable to connect to the parse api')) {
      this.messageText = 'Please check the internet connectivity.';
    } else this.messageText = message.substring(0, 150);
    this.interval = setTimeout((): void => {
      this.messageText = '';
      this.messageChange.emit();
    }, 3000);
  }
}
